/* eslint-disable max-lines */

export const LoginTrackingKeys = {
    LOGIN_SIGN_IN_START: 'login_sign_in_start',
    LOGIN_SIGN_IN_COMPLETE: 'login_sign_in_complete',
    LOGIN_ERRORS: 'login_errors',
    LOGIN_SHOW: 'login_show',
    LOGIN_EMAIL_UPDATE: 'login_email_update',
    LOGIN_TAP_REGISTER: 'login_tap_register',
    SMARTLOCK_ERROR: 'smartlock_error',
    LOGIN_YOLO_ERROR: 'login_yolo_error',
    LOGIN_YOLO_CANCEL: 'login_yolo_cancel',
    SMARTLOCK_MEDIATION_REQUEST: 'smartlock_mediation_request',
    LOGIN_SMARTLOCK_SIGN_IN_START: 'login_smartlock_sign_in_start',
    SMARTLOCK_MEDIATION_RESPONSE: 'smartlock_mediation_response',
    PERMISSIONS_IMPRESSION: 'permissions_impression',
    LOGIN_PHONE_CREATE_PASSWORD: 'login_phone_create_password',
    LOGIN_SEND_DATA: 'login_send_data',
    LOGIN_RESEND_CODE: 'login_resend_code',
    LOGIN_RECOVERY_PASS: 'login_recovery_pass',
    CREATE_PASSWORD_SHOW: 'create_password_show',
    CREATE_PASSWORD_SUCCESS: 'create_password_success',
    LOGIN_SHOW_PIN: 'login_show_pin',
    OTP_PROCESSING: 'otp_processing',
    OTP_COMPLETION: 'otp_completion',
    OTP_TIMER_OVER: 'otp_timer_over',
    PHONE_OTP_PAGE_OPEN: 'phone_otp_page_open',
    PHONE_OTP_SUBMIT_SUCCESS: 'phone_otp_submit_success',
    PHONE_OTP_SUBMIT_FAILED: 'phone_otp_submit_failed',
    PHONE_RESEND_CODE: 'phone_resend_code'
};

export const NotificationTrackingKeys = {
    MY_ACCOUNT_NOTIFICATION_PREF_OPEN: 'my_account_notification_pref_open',
    MY_ACCOUNT_NOTIFICATION_PREF_SET: 'my_account_notification_pref_set',
    MYACCOUNT_NOTIFICATION_CHANGE: 'myaccount_notification_change',
    CONFIRM_NOTIFICATION_CHANGE: 'confirm_notification_change'
};

export const ConsentsPageTracking = {
    CONSENT_SHOW: 'consent_show',
    CONSENT_SUCCESSFUL: 'consent_successful',
    CONSENT_CLICK_CANCEL: 'consent_cancel'
};

export const MyAdsFlowType = {
    DELETION: 'deletion',
    MARK_AS_SOLD: 'mark_as_sold'
};

export const MyAdsTracking = {
    AD_EDIT: 'ad_edit',
    AD_LEARN_MORE: 'ad_learn_more',
    AD_MARK_SOLD_CONFIRM: 'ad_mark_sold_confirm',
    AD_MARK_SOLD_SELECT: 'ad_mark_sold_select',
    AD_MARK_SOLD: 'ad_mark_sold',
    AD_POST_NOW: 'ad_post_now',
    AD_REMOVE_COMPLETE: 'ad_remove_complete',
    AD_REMOVE: 'ad_remove',
    AD_REPUBLISH: 'ad_republish',
    AD_UPGRADE: 'ad_upgrade',
    MONET_SUCCESSFUL: 'monet_successful',
    MY_ADS_SEARCH: 'myads_search',
    MYADS_ERROR: 'myads_error',
    MYADS_VIEW_LISTED: 'myads_view_listed',
    MYADS_FILTER: 'myads_filter',
    POSTING_TAP_POST: 'posting_tap_post',
    AD_DEACTIVATE: 'ad_deactivate',
    AD_DEACTIVATE_COMPLETE: 'ad_deactivate_complete',
    AD_REACTIVATE: 'ad_reactivate',
    DOWNLOAD_LEADS: 'myads_tap_download',
    MYADS_PAGINATION_ERROR: 'myads_tap_page_listings_error',
    MYADS_TAP_PAGINATION: 'myads_tap_page_listings'
};

export const monetRedesignTracking = {
    MONET_PACKAGE_SELECT: 'monet_package_select',
    MONET_PACKAGE_UNCHECKED: 'monet_package_unchecked',
    MONET_HELP_BUTTON: 'monet_help_button',
    MONET_HELP_SCREEN_ACTION: 'monet_help_screen_action',
    MONET_MODIFIED_FILTERS_SUBMIT: 'monet_modified_filters_submit',
    MONET_HOW_IT_WORKS_SCREEN_SHOWN: 'monet_how_it_works_screen_shown',
    MONET_START: 'monet_start',
    VIEW_CART: 'monet_view_cart'
};

export const locationTypes = {
    NEAR_ME: 'near_me',
    PRESET: 'preset',
    DEFAULT: 'default'
};

export const RedirectionTracking = {
    REDIRECTION_CHECK: 'redirection_check'
};

export const AutoLoginTracking = {
    REDIRECTION_AUTOLOGIN_SUCCESSFUL: 'redirection_autologin_successful'
};

export const APP_OPEN = 'app_open';
export const LOGIN_SIGN_IN_COMPLETE = 'login_sign_in_complete';
export const LOCATION_APP_OPEN = 'location_app_open';
export const LOCATION_START = 'location_start';
export const LOCATION_COMPLETE = 'location_complete';
export const MYACCOUNT_SETTINGS = 'myaccount_settings';

export const HOME = 'home'; // Home header location - ok
export const FILTER = 'filter'; // filters location - ok - dynamic parameter desktop
export const SEARCH = 'search'; // header search location or hero search - ok - dynamic parameter desktop
export const POSTING = 'posting'; // posting
export const LISTING = 'listing';
export const OMNIBOX = 'header';
export const CAROUSEL = 'carousel';
export const DEFAULT_FROM = 'default';
export const HEADER_SUGGESTIONS = 'shortcut';

export const VIEW_LISTINGS = 'view_listings';
export const VIEW_LISTINGS_RESULTS_SUMMARY = 'view_listings_results_summary';
export const LISTINGS_RESULTS = 'listings_results';
export const VIEW_LISTINGS_IMPRESSIONS = 'view_listings_impressions';

export const LISTINGS_IMPRESSIONS_CHOSEN_OPTS = {
    HOME: 'home_logo',
    ADPV: 'ad_card',
    FOOTER: 'footer',
    APP_EXIT: 'app_exit'
};

export const VIEW_ITEM_SENDFROM_FILTERS = {
    RELAXED: 'relaxed_filter',
    MAIN: 'standard_result'
};

export const VIEW_ITEM = 'view_item';
export const POPULAR_SEARCH = 'popular_search';

export const POPULAR_SEARCH_EVENTS = {
    POPULAR_SEARCHES_SHOWN: 'popular_searches_shown',
    POPULAR_SEARCHES_CLICKED: 'popular_searches_clicked'
};

export const VIEW_ITEM_TIME = 'view_item_time';

export const LISTINGS_RESULTS_TIME = 'listings_results_time';

export const TYPE_SAVED_HISTORY = 'saved_history';
export const TYPE_TREE = 'tree';
export const TYPE_PARENT_LOCATION = 'parent_location';
export const TYPE_SEARCH = 'search';
export const TYPE_NEAR_ME = 'near_me';
export const TYPE_POPULAR = 'popular';

export const CATEGORY_SELECT_START = 'category_select_start';
export const BROWSE_CATEGORY_SELECT = 'browse_category_select';
export const BROWSE_SUBCATEGORY_SELECT = 'browse_subcategory_select';
export const BROWSE_SUB_CATEGORY_SELECT_COMPLETE = 'browse_sub_category_select_complete';
export const BROWSE_CATEGORY_SHOW = 'browse_category_show';
export const CATEGORY_CHANGE_START = 'category_change_start';
export const CATEGORY_CHANGE = 'category_change';
export const TAP_ALLCATEGORIES = 'tap_allcategories';

export const LISTING_TAP_SELECT_FILTERS = 'listing_tap_select_filters';
export const LISTING_TAP_APPLY_FILTERS = 'listing_tap_apply_filters';
export const LISTING_TAP_REMOVE_FILTERS = 'listing_tap_remove_filters';

export const LISTING_TAP_SELECT_SORT = 'listing_tap_select_sorting';
export const LISTING_TAP_APPLY_SORT = 'listing_tap_apply_sorting';

export const LISTING_TAP_SELECT_VISUALIZATION = 'listing_tap_select_visualization';
export const LISTING_TAP_APPLY_VISUALIZATION = 'listing_tap_apply_visualization';

export const ITEM_TAP_IMAGE = 'item_tap_image';
export const ITEM_TAP_IMAGE_MINIMIZE = 'item_tap_image_minimize';
export const ITEM_TAP_IMAGE_PAGINATION = 'item_tap_image_pagination';
export const ITEM_TAP_REPORT_AD = 'item_tap_report_ad';
export const SOCIAL_TAP_LIKE = 'social_tap_like';
export const SOCIAL_TAP_UNLIKE = 'social_tap_unlike';
export const WISHLIST_HOME_SCR_SHOW = 'wishlist_home_scr_shown';
export const PROFILE_SHOW = 'profile_show';

export const SEARCH_START = 'search_start';
export const SEARCH_TYPE_EVENT = 'search_type';
export const AUTOCOMPLETE_SUBSTRING = 4;
export const SEARCH_COMPLETE = 'search_complete';
export const SEARCH_TYPE = Object.freeze({
    REGULAR: 'regular',
    SAVED_HISTORY: 'savedhistory',
    AUTOCOMPLETE: 'autocomplete',
    AUTOCOMPLETE_CANCEL: 'autocomplete_cancel',
    POPULAR_SEARCH: 'popular_search'
});

export const EXTENDED_LOCATION = 'extended_location';

export const RelatedAdsKeys = {
    CAROUSEL_LISTING_RESULTS: 'carousel_listings_results',
    CAROUSEL_VIEW_LISTING: 'carousel_view_listings',
    VIEW_ITEM: 'view_item',
    RELATED_AD_CLICKED: 'related_ads_clicked',
    RELATED_AD_SHOWN: 'related_ads_shown'
};

export const CLICK_DID_YOU_MEAN_HINT = 'did_you_mean_button';
export const SHOW_DID_YOU_MEAN_HINT = 'did_you_mean_show';

export const FILTER_DRAWER_TRACKING = {
    SEE_ALL_FILTERS: 'tap_see_all_filters',
    SEE_LESS_FILTERS: 'tap_see_less_filters',
    CHIP_REMOVED: 'listing_tap_remove_filters',
    QUICK_FILTER_SELECTION: 'listing_tap_select_filters',
    CHOSEN_OPTION: {
        DRAWER: 'drawer',
        SEE_LESS: 'see_less',
        SEE_ALL: 'see_all'
    },
    QUICK_FILTER: 'quick_filter'
};

/* Filters v2 */
export const FILTERSV2_EVENTS = {
    SEARCH_START: 'search_start',
    SEARCH_COMPLETE: 'search_complete',
    APPLIED_FILTERS_SCROLL: 'filter_scroll',
    REMOVE_TAG: 'listing_tap_remove_filters',
    LISTING_TAP_APPLY_FILTERS: 'listing_tap_apply_filters',
    FILTER_PANE_CLOSE: 'filter_pane_close',
    CLEAR_ALL_FILTER: 'clear_all_filter',
    FILTER_PANE_CLOSE_CONFIRMATION: 'filter_pane_close_confirmation',
    FILTER_TYPE_SELECT: 'filter_type_select'
};

export const SELECT_FROM = {
    FILTER_PAGE: 'filter_page',
    LISTING_PAGE: 'listing_page'
};

export const COMMON_PARAMS = {
    CAT_LEVEL: 'category_level',
    SELECT_FROM: 'select_from',
    FILTERS: 'filters',
    FILTER_CNT: 'filter_count',
    SORTING_OPTION: 'sorting_applied',
    VISUAL_OPTION: 'visual_applied',
    INTERACTION: 'filters_interaction'
};

export const CHOSEN_OPTIONS = {
    CANCEL: 'cancel',
    CHANGE: 'change',
    BACK: 'back'
};

export const ADPV_EVENTS = {
    INSPECTION_AREA: 'inspection_area',
    INSPECTION_TAP_CONFIRM: 'inspection_details_to_ad_tap_confirm',
    INSPECTION_TAP_IGNORE: 'inspection_details_to_ad_tap_ignore',
    INSPECTION_TAP_BACK: 'inspection_details_to_ad_tap_back',
    INSPECTION_SUB_AREA: 'inspection_subarea',
    ITEM_TAP_IMAGE_PAGINATION: 'item_tap_image_pagination',
    FEATURE_VIEW_ALL: 'feature_view_all',
    TECHNICAL_REPORT_HEADER: 'technical_report_header',
    TECHNICAL_REPORT_SUBHEADER: 'technical_report_subheader',
    ADPAGE_TOPBAR: 'adpage_topbar',
    ITEM_TAP_INTERESTED: 'item_tap_interested',
    LEAD_FORM_OPEN: 'lead_form_open',
    AD_PAGE_DIALOG_DISMISS: 'ad_page_dialog_dismiss',
    AD_PAGE_T_AND_C: 'ad_page_t_and_c',
    VAS_SERVICE_CLICKED: 'vas_service_clicked',
    SELECT_LOAN_AMOUNT: 'select_loan_amount',
    EMI_OPTION_SELECT: 'emi_option_select',
    IMAGE_360_CTA: 'image_360_cta',
    VIEW_LEAD_IMPRESSION: 'view_lead_impression',
    FINANCE_OPTION_SELECT: 'finance_option_select',
    VIEW_GET_STARTED_PAGE: 'view_get_started_page',
    CONTACT_BUTTON_TAP: 'contact_button_tap'
};

export const CHECKOUT_EVENTS = {
    VIEW_LOCATION: 'view_location',
    RESERVE: 'reserve'
};

export const MYZONE_EVENTS = {
    MY_ZONE_OPEN: 'view_my_zone',
    MY_ZONE_TAP: 'my_zone_tap',
    MY_ZONE_TAP_SECTION: 'my_zone_tap_section'
};

export const CTA_EVENTS = {
    ITEM_TAP_GET_STARTED: 'item_tap_get_started',
    ITEM_TAP_CONTINUE: 'item_tap_continue'
};

export const MEETING_EVENTS = {
    ITEM_TAP_CALL: 'item_tap_call',
    ITEM_TAP_CHAT: 'item_tap_chat',
    ITEM_TAP_PHONE: 'item_tap_phone',
    TEST_DRIVE_CONFIRM: 'test_drive_confirm',
    TAP_OK_CANCEL_MEETING: 'tap_ok_cancel_meeting',
    BOOKING_TAP_RESCHEDULE: 'booking_tap_reschedule',
    BOOKING_DATETIME_CONFIRM: 'booking_datetime_confirm',
    TAP_VIEW_MEETING: 'tap_view_meeting',
    VIEW_DETAILS: 'view_details',
    VIEW_MEETING_PAGE: 'view_meeting_page'
};

export const FLOW_TYPE_EVENTS = {
    item_tap_chat: true,
    item_intent_chat: true,
    chat_inbox: true,
    chat_list_load_start: true,
    item_chat_tap_send_1st_reply: true,
    qcloud_tap_question: true,
    item_chat_tap_send_success: true,
    item_chat_interv_received: true,
    sr_reply_load: true,
    chat_list_displayed: true,
    qcloud_tap_subtopic: true,
    swipe_bottom_sheet_down: true,
    swipe_bottom_sheet_up: true,
    item_chat_tap_send: true,
    view_my_zone: true,
    my_zone_tap: true,
    my_zone_tap_section: true,
    smartlock_mediation_request: true,
    login_smartlock_sign_in_start: true,
    login_show: true,
    login_sign_in_start: true,
    login_sign_in_complete: true
};

export const FORM_ATTRIBUTE_COMPLETE = 'form_attribute_complete';

export const INSPECTED_CARS_BUNDLE = 'ins_cars_bundle';
export const INSPECTED_CARS_BUNDLE_VIEWALL = 'inspected_ad_view_all';
export const BUNDLE_EVENT_TO_RESULTSET_TYPE = {
    [INSPECTED_CARS_BUNDLE]: {
        bundle: 'inspected_ad_bundle',
        page: 'inspected_ad_page',
        home: 'home_inspected_ad_page'
    }
};
export const INSPECTED_CAR_ICN_CLICK = 'inspected_car_icon';
export const CLEVERTAP_USER_PROPERTIES = {
    OLX_USER_ID: 'olx_user_id',
    SESSION_LONG: 'session_long',
    IDENTITY: 'Identity',
    NAME: 'Name',
    EMAIL: 'Email',
    PHONE: 'Phone',
    OLX_COUNTRY: 'olx_country',
    OLX_COUNTRY_CODE: 'olx_country_code',
    COUNTRY_PREFIX: 'country_prefix',
    REG_DATE: 'reg_date',
    LANG: 'lang',
    DEVICE_LANG: 'device_lang',
    GPLUS_LOGIN: 'gplus_login',
    FB_LOGIN: 'fb_login',
    APPLE_LOGIN: 'apple_login',
    FACEBOOK_ID: 'facebook_id',
    GOOGLE_ID: 'google_id',
    APPLE_ID: 'apple_id',
    TIMEZONE: 'timezone',
    LAST_LOGIN_DATE: 'last_login_date',
    LAST_LOGIN_PLATFORM: 'last_login_platform',
    LAST_LOGIN_MODE: 'last_login_mode',
    IS_BUSINESS: 'is_business',
    IS_PHONE_VISIBLE: 'is_phone_visible',
    PROFILE_PHOTO: 'profile_photo',
    AUTOGENERATED_NAME: 'autogenerated_name',
    DFP: 'dfp',
    PHOTO: 'Photo',
    LAT: 'Lat',
    LONG: 'Long',
    STATE: 'state',
    STATE_ID: 'state_id',
    CITY: 'city',
    CITY_ID: 'city_id',
    LOCALITY: 'locality',
    LOCALITY_ID: 'locality_id',
    REG_PLATFORM: 'reg_platform'
};
export const OLXAUTOS = {
    LANDING_PAGE_OPEN: 'landing_page_open',
    OLXAUTOS_LINKS_TAPPED: 'olxautos_links_tapped',
    OLXAUTOS_FINANCE_SEND_TAPPED: 'hp_finance_tap_send',
    OLXAUTOS_FORM_FIELD_BLUR: 'form_attribute_complete',
    OLXAUTOS_LEAD_FORM_SUBMIT: 'lead_form_submit'
};

export const VAS_TAGS_EVENTS = {
    VAS_TAG_CLICKED: 'vas_tag_clicked'
};

export const VAS_TAGS_HOST = {
    ADPV: 'adpv',
    LISTINGS: 'listings',
    RELATED_AD: 'related_ads'
};
export const HP_OLX_TRACKING = {
    HP_EXCHANGE_BUY: 'exchange_buy_homepage',
    HP_EXCHANGE_SELL: 'exchange_sell_homepage',
    HP_CF_BUY: 'cf_buy_homepage'
};

export const LEAD_FORM_SUBMIT_LISTING = 'lead_form_submit';
export const LEAD_FORM_SUBMIT = 'lead_form_submit';
export const WIDGET_SHOWN = 'widget_shown';
export const OLX_APP_NUDGE_DISPLAYED = 'olx_app_nudge_displayed';
export const OLX_APP_NUDGE_CLICKED = 'olx_app_nudge_clicked';
export const OLX_APP_NUDGE_DISMISSED = 'olx_app_nudge_dismissed';
export const OLX_APP_NUDGE_LOGOUT_PAGE = 'app_nudge_clicked_logout_page';
export const OLX_APP_INSTALL_NUDGE_JOBS = 'app_install_jobs_scr_redirect';
export const OPEN_APP_PATH = '/openapp';

export const GALLERY_INTERMEDIARY_BACK = 'gallery_intermediary_back';

// ADP - gallery navigation event props
export const FLOW_STEP = {
    ADP: 'adp',
    INTERMEDIARY: 'intermediary',
    GALLERY: 'gallery',
    CROSS: 'cross',
    PHONE_BACK: 'phone_back',
    FINANCE_LINK: 'finance_link'
};

export const FLOW_TYPE = {
    ITEM_PAGE: 'itempage',
    FULL_IMAGE_VIEW: 'full_image_view',
    ADPAGE: 'adpage',
    EDITION: 'edition',
    PURCHASE: 'purchase',
    POSTING_SELL_USED: 'posting_sell_used'
};

export const USER_TYPE = {
    FIRST_TIME: 1,
    REPEAT: 2
};

export const FOOTER = {
    HP_FOOTER_IMPRESSION: 'hp_footer_impression'
};

export const CONTACT = {
    CONTACT_BUTTON_TAP: 'contact_button_tap'
};

export const CAR_COMPARE_EVENTS = {
    COMPARE_SHOW: 'car_comparison_show',
    COMPARE_SELECT: 'car_comparison_select',
    COMPARE_UNSELECT: 'car_comparison_unselect',
    COMPARE_POPUP: 'car_comparison_pop_up',
    COMPARE_POPUP_CANCEL: 'car_comparison_pop_up_cancel',
    COMPARE_REMOVE_ALL: 'car_comparison_remove_all',
    COMPARE_ADD: 'car_comparison_add',
    COMPARE_ERROR: 'car_comparison_error'
};

export const CAR_COMPARE_FLOW_STEP = {
    LANDING_PAGE: 'landing_buy',
    LISTING: 'listing',
    ADP: 'adpage',
    POPUP: 'pop_up',
    COMPARE_PAGE: 'car_comparison',
    MY_ZONE: 'my_zone'
};

export const COTF_EVENT_NAME = {
    UNVERIFIED_LEAD_CREATED: 'Unverified_lead_created',
    VERIFIED_LEAD_CREATED: 'Verified_lead_created',
    USER_BLOCKED: 'user_blocked'
};

export const COTF_FIELD_NAME = {
    USE_CASE_1: 'use_case_1',
    USE_CASE_2: 'use_case_2',
    USE_CASE_3: 'use_case_3',
    USE_CASE_4: 'use_case_4',
    USE_CASE_8: 'use_case_8',
    USE_CASE_9: 'use_case_9',
    USE_CASE_10: 'use_case_10'
};

export const LEAD_IMPRESSION_FIELD_NAMES = {
    PHONE: 'phone',
    CHAT: 'chat',
    GET_STARTED: 'get_started',
    I_AM_INTERESTED: 'i_am_interested',
    RESERVE: 'reserve',
    NOTIFY_ME: 'notify_me',
    TEST_DRIVE: 'test_drive',
    WHATSAPP: 'whatsapp'
};

export const VALUATION_COMPLETE = 'valuation_complete';

export const VALUATION_PAGE_OPEN = 'valuation_page_open';

export const SOCIAL_VIEW_NETWORK = 'social_view_network';

export const SOCIAL_PROFILE_SHARE = 'social_profile_share';

export const SELECT_FROM_MY_PROFILE = 'my_profile';

export const SELECT_FROM_OTHER_PROFILE = 'other_profile';

export const SELECT_FROM_PROFILE = 'profile';

export const SELECT_FROM_OWN_FOLLOWERS = 'own_followers';

export const SELECT_FROM_OTHER_FOLLOWERS = 'other_followers';

export const SELECT_FROM_OWN_FOLLOWING = 'own_following';

export const SELECT_FROM_OTHER_FOLLOWING = 'other_following';

export const CLICK_TO_CALL_BANNER_EVENT = 'call_us_click';

export const SELECT_FROM_CAR_CATEGORY = 'car_category';

export const CHOSEN_OPTION_CALL_US = 'call_us';

export const PROMO_CARD_CLICK = 'promo_card_click';

export const CAR_CATEGORY = 'car_category';

export const CLEVERTAP_PROPERTY_MAP = {
    ad_post_now: ['user_status', 'user_type', 'origin', 'item_status', 'cC', 'item_id', 'images_count', 'category_id', 'user_id', 'category_level2_id', 'category_level1_name', 'category_level1_id', 'category_level2_name', 'device_fingerprint', 'business_region', 'brand', 'channel', 'first_app_launch_date', 'rE', 'user_token', 'creation_date', 'v', 'ts', 'tN', 'c_add', 'eN', 'location_auto_manual', 'view_ad', 'gps_on_off', 'dt', 'seller_id', 'app_type', 'gaid', 'long', 'lat', 'city_id', 'item_price', 'tracking_token', 'session_long', 'feed_version', 'state_name', 'state_id', 'city_name', 'neighbourhood_id', 'neighbourhood_name', 'hAcc', 'vAcc', 'visual_applied', 'user_sk', 'user_date', 'used_app', 'user_affected', 'verified_lister', 'unit_id', 'variants_shown', 'verified_user_ad', 'user_category', 'val', 'ninjaVer', 'facebook_id', 'mv', 'app_version', 'region_id', 'browsing_mode', 'c', 's', 't', 'cl', 'sl', 'appsflyer_id', 'acquisition_channel_ad_name', 'acquisition_channel_group_name', 'acquisition_channel_type_name', 'acquisition_channel_campaign_name', 'acquisition_channel_medium_name', 'acquisition_channel_keyword_name', 'acquisition_channel_term_name', 'env', 'bR', 'campaign_click_ad', 'campaign_id', 'acquisition_channel_campaign_ad_group', 'acquisition_channel_territory', 'acquisition_channel_device', 'acquisition_channel_network', 'ad_id', 'target_id', 'group_id', 'campaign_type', 'campaign_url', 'select_from', 'location_type', 'place_selected_id', 'resultset_type', 'filter_count', 'fa_ad', 'intervention_id', 'interv_msg_id', 'intervention_type', 'login_type', 'error_message', 'login_method', 'login_submethod', 'browser_detail', 'os_version', 'page_number', 'result_count', 'seen_at'],
    app_open: ['ts', 'ip_address', 'user_id', 'channel'],
    browse_category_select: ['cC', 'category_level1_id', 'category_id', 'category_level1_name', 'eN', 'location_auto_manual', 'brand', 'device_fingerprint', 'business_region', 'channel', 'first_app_launch_date', 'user_token', 'category_level', 'ts', 'tN', 'city_id', 'app_type', 'gaid', 'user_id', 'long', 'lat', 'user_date', 'used_app', 'user_affected', 'category_level2_id2', 'category_level2_id3', 'verified_lister', 'unit_id', 'verified_user_ad', 'user_category', 'val', 'quick_filter', 'tracking_token', 'session_long', 'state_name', 'state_id', 'origin', 'city_name', 'category_level2_name', 'category_level2_id', 'neighbourhood_id', 'neighbourhood_name', 'mv', 'experiment_variant', 'app_version', 'browsing_mode', 'acquisition_channel_ad_name', 'acquisition_channel_group_name', 'acquisition_channel_type_name', 'acquisition_channel_campaign_name', 'acquisition_channel_medium_name', 'acquisition_channel_term_name', 'region_id', 'bR', 'resultset_type', 'result_count', 'images_count', 'page_number', 'fa_ad_count', 'location_type', 'place_selected_id', 'browsing_location_id', 'reason', 'appsflyer_id', 'c', 's', 't', 'cl', 'sl', 'env', 'ifv', 'location_auto_manual', 'category_level1_id', 'acquisition_channel_keyword_name', 'campaign_click_ad', 'campaign_id', 'acquisition_channel_campaign_ad_group', 'acquisition_channel_territory', 'acquisition_channel_device', 'acquisition_channel_network', 'ad_id', 'target_id', 'group_id', 'campaign_type', 'campaign_url', 'total_pages', 'filter_count', 'sorting_applied', 'login_method', 'login_submethod', 'error_message', 'search_string', 'login_type', 'chosen_option', 'search_type', 'search_user_query', 'fa_ad_count_impression', 'result_count_impression', 'time_spent', 'intervention_id', 'interv_msg_id', 'item_id', 'intervention_type', 'flow_step', 'browser_detail', 'os_version', 'login_city', 'seen_at', 'item_status', 'flow_type'],
    item_chat_tap_chat: ['user_type', 'cC', 'origin', 'item_id', 'category_id', 'user_id', 'item_price', 'device_fingerprint', 'business_region', 'first_app_launch_date', 'user_token', 'channel', 'ts', 'experiment_variant', 'creation_date', 'resultset_id', 'city_id', 'c_add', 'category_level1_name', 'category_level1_id', 'category_level2_name', 'browsing_mode', 'user_category', 'search_type', 'eN', 'chat_origin', 'chosen_option', 'reason', 'filters', 'long', 'lat', 'verified_user_ad', 'images_count', 'item_status', 'feed_version', 'location_auto_manual', 'view_ad', 'gps_on_off', 'session_long', 'tracking_token', 'shown_at', 'state_name', 'state_id', 'city_name', 'spell_key', 'spell_version', 'app_version', 'os_version', 'device_brand', 'user_agent', 'neighbourhood_id', 'neighbourhood_name', 'vAcc', 'hAcc', 'ninjaVer', 'facebook_id', 'env', 'user_sk', 'category_sk', 'channel_sk', 'user_date', 'credits', 'used_app', 'user_affected', 'category_level2_id2', 'category_level2_id3', 'connection_type', 'dom_content_loaded', 'cross_domain_session_long', 'verified_lister', 'unit_id', 'cp', 'variants_shown', 'val', 'config_id', 'visual_applied', 'mv', 'region_id', 'bR', 'acquisition_channel_group_name', 'acquisition_channel_type_name', 'acquisition_channel_campaign_name', 'acquisition_channel_medium_name', 'acquisition_channel_ad_name', 'acquisition_channel_term_name', 'sorting_applied', 'total_pages', 'search_user_query', 'ad_index_id', 'field_name', 'package_id', 'browsing_location_id', 'result_count', 'location_type', 'intervention_id', 'intervention_type', 'seen_at', 'interv_msg_id', 'login_type', 'error_message', 'login_method', 'login_submethod', 'browser_detail', 'place_selected_id', 'resultset_type', 'fa_ad_count', 'fa_ad_count_impression', 'result_count_impression', 'time_spent', 'quick_filter', 'offer_price', 'campaign_id', 'acquisition_channel_campaign_ad_group', 'acquisition_channel_territory', 'acquisition_channel_device', 'acquisition_channel_network', 'ad_id', 'target_id', 'group_id', 'campaign_type', 'campaign_url', 'campaign_click_ad', 'acquisition_channel_keyword_name', 'userCategory', 'ifv', 'appsflyer_id', 'cl', 'c', 'sl', 's', 't'],
    item_chat_tap_send_1st_reply: ['user_type', 'chosen_option', 'device_fingerprint', 'cC', 'origin', 'item_id', 'category_id', 'item_price', 'user_id', 'city_id', 'business_region', 'channel', 'first_app_launch_date', 'tN', 'ts', 'creation_date', 'category_level1_id', 'category_level1_name', 'category_level2_id', 'category_level2_name', 'long', 'lat', 'user_category', 'eN', 'flow_type', 'browsing_mode', 'flow_step', 'experiment_variant', 'dt', 'app_type', 'seller_id', 'gaid', 'user_status', 'app_version', 'item_status', 'filters_applied_price', 'os_version', 'spell_key', 'images_count', 'filters_applied_map', 'feed_version', 'user_agent', 'spell_version', 'filters_applied_specific', 'session_long', 'state_id', 'state_name', 'city_name', 'neighbourhood_id', 'neighbourhood_name', 'vAcc', 'hAcc', 'env', 'channel_sk', 'user_date', 'credits', 'used_app', 'user_affected', 'category_level2_id2', 'category_level2_id3', 'connection_type', 'dom_content_loaded', 'visual_applied', 'cross_domain_session_long', 'verified_lister', 'unit_id', 'cp', 'variants_shown', 'verified_user_ad', 'val', 'config_id', 'facebook_id', 'mv', 'region_id', 'c', 'bR', 'sl', 'cl', 'ifv', 's', 't', 'appsflyer_id', 'acquisition_channel_ad_name', 'acquisition_channel_group_name', 'acquisition_channel_type_name', 'acquisition_channel_campaign_name', 'acquisition_channel_medium_name', 'acquisition_channel_keyword_name', 'acquisition_channel_term_name', 'campaign_click_ad', 'campaign_id', 'acquisition_channel_campaign_ad_group', 'acquisition_channel_territory', 'acquisition_channel_device', 'acquisition_channel_network', 'ad_id', 'target_id', 'group_id', 'campaign_type', 'campaign_url', 'location_type', 'intervention_id', 'intervention_type', 'seen_at', 'interv_msg_id', 'place_selected_id', 'result_count', 'page_number', 'resultset_type', 'offer_price', 'reason'],
    monet_payment_cancel: ['ad_package_price', 'user_type', 'cC', 'reason', 'origin', 'select_from', 'package_id', 'city_id', 'user_id', 'state_name', 'device_fingerprint', 'brand', 'business_region', 'channel', 'first_app_launch_date', 'rE', 'payment_id', 'user_token', 'v', 'ts', 'tN', 'neighbourhood_id', 'c_add', 'state_id', 'city_name', 'neighbourhood_name', 'product_type', 'order_id', 'eN', 'user_status', 'dt', 'app_type', 'images_count', 'item_status', 'item_id', 'category_id', 'category_level1_name', 'category_level1_id', 'category_level2_name', 'category_level2_id', 'gaid', 'creation_date', 'location_auto_manual', 'view_ad', 'gps_on_off', 'long', 'lat', 'seller_id', 'result_count', 'tracking_token', 'session_long', 'item_price', 'feed_version', 'login_method', 'vAcc', 'hAcc', 'ninjaVer', 'env', 'user_sk', 'category_sk', 'channel_sk', 'user_date', 'credits', 'used_app', 'user_affected', 'category_level2_id2', 'category_level2_id3', 'connection_type', 'dom_content_loaded', 'visual_applied', 'cross_domain_session_long', 'verified_lister', 'chosen_option', 'unit_id', 'cp', 'variants_shown', 'verified_user_ad', 'user_category', 'val', 'flow_step', 'facebook_id', 'mv', 'c', 'cl', 'sl', 's', 't', 'app_version', 'region_id', 'appsflyer_id', 'bR', 'acquisition_channel_ad_name', 'acquisition_channel_group_name', 'acquisition_channel_type_name', 'acquisition_channel_campaign_name', 'acquisition_channel_medium_name', 'acquisition_channel_keyword_name', 'acquisition_channel_term_name', 'browsing_mode', 'location_type', 'platform_type', 'entry_point', 'chosen_option', 'coupon_type', 'coupon_code', 'coupon_discount_amount', 'initial_value', 'coupon_discount_percentage', 'coupon_id', 'coupon_campaign_id'],
    monet_start: ['user_status', 'user_type', 'device_fingerprint', 'reason', 'images_count', 'item_status', 'cC', 'city_id', 'result_count', 'product_type', 'category_id', 'state_name', 'user_id', 'category_level1_name', 'category_level1_id', 'category_level2_name', 'category_level2_id', 'business_region', 'channel', 'first_app_launch_date', 'ts', 'state_id', 'city_name', 'eN', 'dt', 'app_type', 'gaid', 'lat', 'long', 'select_from', 'item_price', 'session_long', 'login_method', 'credits', 'used_app', 'user_affected', 'category_level2_id2', 'category_level2_id3', 'connection_type', 'visual_applied', 'verified_lister', 'variants_shown', 'verified_user_ad', 'user_category', 'facebook_id', 'experiment_variant', 'app_version', 'browsing_mode', 'region_id', 'mv', 'acquisition_channel_ad_name', 'acquisition_channel_group_name', 'acquisition_channel_type_name', 'acquisition_channel_campaign_name', 'acquisition_channel_medium_name', 'acquisition_channel_term_name', 'c', 'cl', 'sl', 's', 't', 'order_id', 'bR', 'ifv', 'appsflyer_id', 'acquisition_channel_keyword_name', 'campaign_click_ad', 'campaign_id', 'acquisition_channel_campaign_ad_group', 'acquisition_channel_territory', 'acquisition_channel_device', 'acquisition_channel_network', 'ad_id', 'target_id', 'group_id', 'campaign_type', 'campaign_url', 'location_type', 'package_id', 'page_number', 'intervention_id', 'interv_msg_id', 'intervention_type', 'seen_at', 'login_type', 'login_submethod', 'browser_detail', 'os_version', 'resultset_type', 'flow_step', 'select_from', 'platform_type', 'entry_point', 'design_type', 'chosen_option'],
    monet_successful: ['user_status', 'user_type', 'device_fingerprint', 'reason', 'city_id', 'cC', 'product_type', 'package_id', 'category_id', 'state_name', 'category_level1_name', 'category_level1_id', 'user_id', 'category_level2_name', 'category_level2_id', 'images_count', 'item_status', 'item_id', 'origin', 'business_region', 'channel', 'first_app_launch_date', 'ts', 'city_name', 'neighbourhood_id', 'flow_type', 'eN', 'dt', 'app_type', 'gaid', 'lat', 'long', 'select_from', 'item_price', 'ad_package_price', 'session_long', 'creation_date', 'feed_version', 'env', 'user_date', 'credits', 'used_app', 'user_affected', 'category_level2_id2', 'category_level2_id3', 'connection_type', 'dom_content_loaded', 'visual_applied', 'cross_domain_session_long', 'verified_lister', 'unit_id', 'cp', 'verified_user_ad', 'user_category', 'config_id', 'chosen_option', 'login_method', 'result_count', 'flow_step', 'app_version', 'region_id', 'browsing_mode', 'c', 'cl', 'sl', 's', 't', 'appsflyer_id', 'mv', 'acquisition_channel_ad_name', 'acquisition_channel_group_name', 'acquisition_channel_type_name', 'acquisition_channel_campaign_name', 'acquisition_channel_medium_name', 'acquisition_channel_keyword_name', 'acquisition_channel_term_name', 'campaign_url', 'location_type', 'page_number', 'entry_point', 'platform_type', 'chosen_option', 'coupon_type', 'coupon_code', 'coupon_discount_amount', 'initial_value', 'coupon_discount_percentage', 'coupon_id', 'coupon_campaign_id'],
    posting_category_select: ['user_status', 'user_type', 'device_fingerprint', 'verified_lister', 'category_level1_name', 'category_level1_id', 'channel', 'ts', 'first_app_launch_date', 'user_id', 'state_id', 'city_id', 'location_auto_manual', 'dt', 'app_type', 'gaid', 'long', 'lat', 'category_level2_id', 'category_level2_name', 'tracking_token', 'session_long', 'state_name', 'city_name', 'visual_applied', 'credits', 'used_app', 'user_affected', 'category_level2_id2', 'category_level2_id3', 'cross_domain_session_long', 'unit_id', 'cp', 'variants_shown', 'verified_user_ad', 'user_category', 'val', 'config_id', 'chosen_option', 'item_price', 'app_version', 'reason', 'browsing_mode', 'item_id', 'region_id', 'acquisition_channel_ad_name', 'acquisition_channel_group_name', 'acquisition_channel_type_name', 'acquisition_channel_medium_name', 'acquisition_channel_term_name', 'acquisition_channel_campaign_name', 'bR', 'c', 's', 'sl', 't', 'cl', 'appsflyer_id', 'ifv', 'acquisition_channel_keyword_name', 'campaign_click_ad', 'campaign_id', 'acquisition_channel_campaign_ad_group', 'acquisition_channel_territory', 'acquisition_channel_device', 'acquisition_channel_network', 'ad_id', 'target_id', 'group_id', 'campaign_type', 'campaign_url', 'resultset_type', 'result_count', 'images_count', 'page_number', 'total_pages', 'fa_ad_count', 'location_type', 'place_selected_id', 'sorting_applied', 'fa_ad_count_impression', 'result_count_impression', 'time_spent', 'quick_filter', 'login_type', 'error_message', 'login_method', 'login_submethod', 'browser_detail', 'os_version', 'intervention_id', 'interv_msg_id', 'intervention_type', 'search_string', 'item_status', 'field_name', 'flow_step', 'search_type', 'search_user_query', 'package_id', 'product_type'],
    posting_successful_post: ['product_brand', 'user_status', 'cC', 'item_id', 'item_status', 'category_id', 'user_type', 'images_count', 'city_id', 'category_level1_name', 'category_level1_id', 'category_level2_name', 'category_level2_id', 'user_id', 'state_name', 'flow_type', 'device_fingerprint', 'business_region', 'verified_lister', 'channel', 'first_app_launch_date', 'creation_date', 'tN', 'user_token', 'ts', 'c_add', 'state_id', 'city_name', 'neighbourhood_name', 'ad_index_id', 'item_price', 'origin', 'lat', 'long', 'eN', 'location_auto_manual', 'gps_on_off', 'view_ad', 'dt', 'app_type', 'gaid', 'suggested_price', 'tracking_token', 'listing_id', 'level', 'feed_version', 'session_long', 'vAcc', 'hAcc', 'item_projects', 'item_furnished', 'app_version', 'region_id', 'browsing_mode', 'env', 'user_sk', 'category_sk', 'channel_sk', 'user_date', 'credits', 'used_app', 'user_affected', 'category_level2_id2', 'category_level2_id3', 'connection_type', 'dom_content_loaded', 'visual_applied', 'cross_domain_session_long', 'chosen_option', 'unit_id', 'cp', 'variants_shown', 'verified_user_ad', 'user_category', 'val', 'config_id', 'mv', 'c', 'test_name', 's', 't', 'cl', 'test_variation', 'sl', 'bR', 'ifv', 'appsflyer_id', 'acquisition_channel_ad_name', 'acquisition_channel_group_name', 'acquisition_channel_type_name', 'acquisition_channel_campaign_name', 'acquisition_channel_medium_name', 'acquisition_channel_keyword_name', 'acquisition_channel_term_name', 'campaign_click_ad', 'campaign_id', 'acquisition_channel_campaign_ad_group', 'acquisition_channel_territory', 'acquisition_channel_device', 'acquisition_channel_network', 'ad_id', 'target_id', 'group_id', 'campaign_type', 'campaign_url', 'reason', 'location_type', 'place_selected_id', 'field_name', 'nudge_type', 'nudge_shown_last_screen', 'suggested_image_count'],
    posting_tap_post: ['user_status', 'user_type', 'cC', 'login_method', 'device_fingerprint', 'verified_lister', 'channel', 'first_app_launch_date', 'user_token', 'ts', 'user_id', 'location_auto_manual', 'dt', 'app_type', 'gaid', 'long', 'lat', 'category_id', 'flow_type', 'state_name', 'state_id', 'city_id', 'city_name', 'images_count', 'visual_applied', 'result_count', 'location_type', 'place_selected_id', 'item_status', 'item_price', 'group_id', 'reason', 'filter_count', 'login_type', 'quick_filter', 'user_date', 'filters', 'posting_step', 'invite_source', 'invite_campaign', 'credits', 'feed_version', 'intents', 'map_change_location', 'used_app', 'user_affected', 'intervention_type', 'connection_type', 'dom_content_loaded', 'first_byte', 'interactive', 'loaded', 'image_size_post', 'image_size_pre', 'response_status', 'picture_origin', 'cross_domain_session_long', 'filters_interaction', 'params_referrer', 'host', 'location_id', 'log_time', 'project_id', 'unit_id', 'cp', 'my_network', 'invite_tracking_date', 'message_displayed', 'verified_user_ad', 'kyc_status', 'field_name', 'params_suggested_price', 'lead_id', 'posting_variant', 'pre_approval_status', 'pre_approval_id', 'lead_source', 'persistence', 'match_type', 'val', 'config_id', 'resultset_type', 'chosen_option', 'facebook_id', 'mv', 'app_version', 'browsing_mode', 'acquisition_channel_group_name', 'acquisition_channel_type_name', 'acquisition_channel_campaign_name', 'acquisition_channel_medium_name', 'acquisition_channel_ad_name', 'acquisition_channel_term_name', 'region_id', 'sorting_applied', 'total_pages', 'fa_ad_count', 'c', 'sl', 't', 's', 'cl', 'category_level1_id', 'category_level1_name', 'search_string', 'bR', 'item_id', 'category_level2_id', 'category_level2_name', 'error_message', 'experiment_variant', 'appsflyer_id', 'ifv', 'shown_at', 'source', 'acquisition_channel_keyword_name', 'campaign_click_ad', 'acquisition_channel_campaign_ad_group', 'campaign_id', 'acquisition_channel_territory', 'acquisition_channel_device', 'acquisition_channel_network', 'ad_id', 'target_id', 'campaign_type', 'campaign_url', 'browsing_location_id', 'fa_ad', 'browser_detail', 'os_version', 'login_city', 'fa_ad_count_impression', 'result_count_impression', 'time_spent', 'search_user_query'],
    view_item: ['item_id', 'ip_address', 'ts', 'user_id', 'channel', 'product_price', 'product_brand', 'product_model', 'category_level2_name'],
    item_tap_call: ['seller_id', 'user_type', 'cC', 'origin', 'item_id', 'category_id', 'user_id', 'item_price', 'device_fingerprint', 'business_region', 'first_app_launch_date', 'user_token', 'channel', 'ts', 'experiment_variant', 'creation_date', 'resultset_id', 'city_id', 'c_add', 'category_level1_name', 'category_level1_id', 'category_level2_name', 'browsing_mode', 'user_category', 'search_type', 'eN', 'chat_origin', 'chosen_option', 'reason', 'filters', 'long', 'lat', 'verified_user_ad', 'images_count', 'item_status', 'feed_version', 'location_auto_manual', 'view_ad', 'gps_on_off', 'session_long', 'tracking_token', 'shown_at', 'state_name', 'state_id', 'city_name', 'spell_key', 'spell_version', 'app_version', 'os_version', 'device_brand', 'user_agent', 'neighbourhood_id', 'neighbourhood_name', 'vAcc', 'hAcc', 'ninjaVer', 'facebook_id', 'env', 'user_sk', 'category_sk', 'channel_sk', 'user_date', 'credits', 'used_app', 'user_affected', 'category_level2_id2', 'category_level2_id3', 'connection_type', 'dom_content_loaded', 'cross_domain_session_long', 'verified_lister', 'unit_id', 'cp', 'variants_shown', 'val', 'config_id', 'visual_applied', 'mv', 'region_id', 'bR', 'acquisition_channel_group_name', 'acquisition_channel_type_name', 'acquisition_channel_campaign_name', 'acquisition_channel_medium_name', 'acquisition_channel_ad_name', 'acquisition_channel_term_name', 'sorting_applied', 'total_pages', 'search_user_query', 'ad_index_id', 'field_name', 'package_id', 'browsing_location_id', 'result_count', 'location_type', 'intervention_id', 'intervention_type', 'seen_at', 'interv_msg_id', 'login_type', 'error_message', 'login_method', 'login_submethod', 'browser_detail', 'place_selected_id', 'resultset_type', 'fa_ad_count', 'fa_ad_count_impression', 'result_count_impression', 'time_spent', 'quick_filter', 'offer_price', 'campaign_id', 'acquisition_channel_campaign_ad_group', 'acquisition_channel_territory', 'acquisition_channel_device', 'acquisition_channel_network', 'ad_id', 'target_id', 'group_id', 'campaign_type', 'campaign_url', 'campaign_click_ad', 'acquisition_channel_keyword_name', 'userCategory', 'ifv', 'appsflyer_id', 'cl', 'c', 'sl', 's', 't'],
    monet_package_select: ['user_id', 'category_level1_id', 'category_level1_name', 'category_level2_id', 'category_level2_name', 'platform', 'package_price', 'type_of_package', 'no_of_Ads_package', 'platform_type', 'city_id', 'package_category', 'no_of_ads_package', 'select_from', 'days_validity', 'banner_visible', 'package_type', 'entry_point', 'chosen_option', 'coupon_type', 'coupon_code', 'coupon_discount_amount', 'initial_value', 'coupon_discount_percentage', 'coupon_id', 'coupon_campaign_id'],
    monet_package_unchecked: ['user_id', 'category', 'subcategory', 'platform', 'package_price', 'type_of_package', 'no_of_Ads_package', 'package_category', 'select_from', 'days_validity', 'banner_visible', 'package_type', 'platform_type', 'entry_point', 'no_of_ads_package'],
    monet_help_button: ['user_id', 'category', 'subcategory', 'package_price', 'type_of_package', 'select_from', 'platform_type', 'entry_point', 'screen_position'],
    ad_edit_updated: ['user_id', 'neighbourhood_id_old', 'country_id', 'category_id', 'category_key', 'subcategory_id', 'category_name', 'platform_type', 'subcategory_id', 'ad_id', 'neighbourhood_id_new', 'state_id_new', 'city_id_new', 'state_name_new', 'neighbourhood_name_new', 'city_name_new', 'state_id_old', 'state_name_old', 'city_name_old', 'neighbourhood_name_old'],
    monet_payment_iframe_screen: ['user_id', 'category_level1_id', 'category_level1_name', 'category_level2_id', 'category_level2_name', 'package_price', 'platform', 'package_id', 'platform_type', 'category_level1_id', 'origin', 'select_from', 'product_type', 'city_id', 'state_id', 'neighbourhood_id', 'neighbourhood_name', 'images_count', 'creation_date', 'item_status', 'orderId', 'entry_point', 'chosen_option', 'coupon_type', 'coupon_code', 'coupon_discount_amount', 'initial_value', 'coupon_discount_percentage', 'coupon_id', 'coupon_campaign_id'],
    monet_payment_iframe_error: ['user_id', 'category', 'subcategory', 'package_price', 'platform', 'error', 'platform_type', 'entry_point', 'chosen_option', 'coupon_type', 'coupon_code', 'coupon_discount_amount', 'initial_value', 'coupon_discount_percentage', 'coupon_id', 'coupon_campaign_id'],
    limit_hitter: ['user_id', 'category', 'subcategory', 'daysRemaining', 'package_price', 'platform'],
    video_package_applied: ['user_id', 'category', 'subcategory', 'platform', 'state_name', 'city_name', 'neighbourhood_name'],
    view_showroom: ['seller_id', 'viewer_id', 'origin', 'platform'],
    showroom_view_all: ['seller_id', 'viewer_id', 'origin', 'platform'],
    showroom_tap_call: ['seller_id', 'viewer_id', 'origin', 'platform'],
    my_ads: ['user_id', 'platform_type', 'select_from', 'city', 'state', 'app_version'],
    monet_landing_page: ['origin', 'user_status', 'user_id', 'app_version', 'platform_type', 'city', 'entry_point', 'monet_start_scr_filter_applied'],
    monet_view_cart: ['package_id', 'platform_type', 'category_level1_id', 'category_level1_name', 'category_level2_id', 'category_level2_name', 'select_from', 'user_status', 'user_id', 'state_id', 'state_name', 'city_id', 'city_name', 'neighbourhood_id', 'neighbourhood_name', 'origin', 'entry_point', 'coupon_campaign_id', 'chosen_option'],
    myaccount_show: ['user_id', 'platform_type', 'app_version'],
    monet_selection: ['package_id', 'neighbourhood_id', 'neighbourhood_name', 'city_id', 'city_name', 'state_id', 'state_name', 'category_level1_id', 'category_level1_name', 'category_level2_id', 'category_level2_name', 'platform_type', 'select_from', 'user_status', 'user_id', 'origin', 'entry_point'],
    ad_upgrade: ['category_level1_id', 'category_level1_name', 'category_level2_id', 'category_level2_name', 'user_status', 'item_id', 'images_count', 'creation_date', 'item_status', 'city_id', 'state_id', 'app_version', 'origin', 'user_id', 'platform_type'],
    buy_intent_banner_shown: ['category_l1_id'],
    buy_intent_banner_action: ['category_l1_id', 'action'],
    buy_intent_feature_filled: ['category_l1_id', 'feature_name'],
    buy_intent_submit: ['category_l1_id', 'feature_name'],
    monet_help_screen_action: ['action', 'select_from', 'platform_type', 'entry_point', 'user_id'],
    monet_modified_filters_submit: ['category_level1_id', 'category_level1_name', 'category_level2_id', 'category_level2_name', 'city_id', 'category_change', 'location_change', 'platform_type', 'entry_point', 'user_id'],
    monet_how_it_works_screen_shown: ['user_id', 'platform_type', 'entry_point', 'package_price', 'type_of_package', 'package_type'],
    home_top_banner_shown: ['countdown_shown'],
    homepage_banner_clicked: ['countdown_clicked'],
    monet_category_select: ['user_id', 'category_level1_id', 'category_level1_name', 'entry_point', 'platform_type', 'campaign_id', 'wzrk_dl'],
    monet_subcategory_select: ['user_id', 'category_level1_id', 'category_level1_name', 'category_level2_id', 'category_level2_name', 'entry_point', 'platform_type', 'campaign_id', 'wzrk_dl'],
    nudge_shown: ['nudge_type', 'nudge_screen', 'item_id', 'suggested_image_count', 'platform_type', 'category_id', 'user_type', 'images_count', 'user_id', 'user_status', 'category_level1_name', 'category_level1_id', 'category_level2_name', 'category_level2_id', 'origin', 'lat', 'long', 'eN'],
    nudge_action: ['nudge_type', 'nudge_screen', 'item_id', 'suggested_image_count', 'platform_type', 'category_id', 'user_type', 'images_count', 'user_id', 'user_status', 'category_level1_name', 'category_level1_id', 'category_level2_name', 'category_level2_id', 'origin', 'lat', 'long', 'eN'],
    pkg_renew_scr_shown: ['type', 'days_to_go', 'select_from', 'user_id', 'category_level_1_id', 'category_level_2_id', 'type_of_package', 'no_of_ads', 'platform_type'],
    pkg_renew_click: ['type', 'days_to_go', 'select_from', 'user_id', 'category_level_1_id', 'category_level_2_id', 'type_of_package', 'no_of_ads', 'platform_type'],
    monet_cart_scr_explore_all_click: ['origin', 'category_level_1_id', 'category_level_2_id', 'category_level_1_name', 'category_level_2_name', 'user_id', 'platform_type'],
    monet_coupon_applied: ['seller_id', 'category_level1_id', 'category_level1_name', 'category_level2_id', 'category_level2_name', 'platform', 'platform_type', 'city_id', 'select_from', 'entry_point', 'chosen_option', 'coupon_type', 'coupon_code', 'coupon_discount_amount', 'initial_value', 'coupon_discount_percentage', 'coupon_id', 'coupon_campaign_id'],
    monet_cart_scr_coupon_read_more: ['seller_id', 'category_level1_id', 'category_level1_name', 'category_level2_id', 'category_level2_name', 'platform', 'platform_type', 'origin', 'entry_point', 'coupon_discount', 'coupon_code'],
    monet_cart_scr_coupon_view_all: ['seller_id', 'category_level1_id', 'category_level1_name', 'category_level2_id', 'category_level2_name', 'platform', 'platform_type', 'origin', 'entry_point', 'result_count'],
    monet_coupon_remove: ['seller_id', 'category_level1_id', 'category_level1_name', 'category_level2_id', 'category_level2_name', 'platform', 'platform_type', 'city_id', 'select_from', 'entry_point', 'chosen_option', 'coupon_type', 'coupon_code', 'coupon_discount_amount', 'initial_value', 'coupon_discount_percentage', 'coupon_id', 'coupon_campaign_id'],
    monet_coupon_not_valid: ['seller_id', 'category_level1_id', 'category_level1_name', 'category_level2_id', 'category_level2_name', 'platform', 'platform_type', 'origin', 'entry_point', 'coupon_code']
};

export const CLICKED_RELATED_LISTINGS = 'clicked_related_listings';

export const FinanceBannerKeys = {
    FINANCE_BANNER: 'finance_banner',
    AVAIL_FINANCE_CLICKED: 'avail_finance_clicked',
    FORM_ERROR_SHOWN: 'form_error_shown',
    CTA_FORM_REDIRECTED: 'cta_form_redirected',
    RE_LANDING_FORM_CT_FORM: 're_landing_from_ct_form'
};

export const DYNAMIC_CONTENT = {
    CLICKED_READ_MORE: 'clicked_read_more',
    CLICKED_DC: 'clicked_dc'
};

export const GALLERY_VIEW_CTA = {
    gallery_item_tap_call: 'gallery_item_tap_call',
    gallery_item_tap_chat: 'gallery_item_tap_chat',
    gallery_item_chat_tap_make_offer: 'gallery_item_chat_tap_make_offer'
};

export const TRACK_EVENT = {
    HOME_SCREEN_REDIRECT: 'app_install_home_scr_redirect',
    LISTING_SCREEN_REDIRECT: 'app_install_listing_scr_redirect',
    DETAIL_PAGE_REDIRECT: 'app_install_adpv_redirect',
    DETAIL_PAGE_BOTTOM_REDIRECT: 'app_install_adpv_bottom_redirect'
};

export const CAMPAIGN = {
    HOME_SCREEN: 'footer_home',
    LISTING_SCREEN: 'footer_clp',
    DETAIL_PAGE_BOTTOM: 'adpv_bottom'
};

export const INLINE_WIDGET_TRACK = {
    SHOWN: 'inline_filters_shown',
    SELECT: 'inline_filters_select'
};

export const EXTERNAL_CAT_TRACK = {
    external_icon_shown: 'external_icon_shown',
    externa_icon_clicked: 'external_icon_clicked'
};

export const QUICK_FILTER_TRACK = {
    quick_filters_select: 'quick_filters_select',
    filters_discard_screen_shown: 'filters_discard_screen_shown',
    filter_discard_scr_apply_tap: 'filter_discard_scr_apply_tap',
    filter_discard_scr_discard_tap: 'filter_discard_scr_discard_tap',
    filter_clear_all_screen_shown: 'filter_clear_all_screen_shown',
    filter_clear_all_scr_apply_clear: 'filter_clear_all_scr_apply_clear',
    filter_clear_all_scr_apply_cancel: 'filter_clear_all_scr_apply_cancel'
};

export const APP_INSTALL_PAGE_REDIRECT = 'app_install_page_redirect';
export const POSTING_SUBMIT_POST = 'posting_submit_post';
export const SELL_PAGE = {
    sell_page_shown: 'sell_page_shown',
    sell_page_clicked: 'sell_page_clicked',
    sell_page_home_scr_shown: 'sell_page_home_scr_shown',
    sell_page_home_scr_clicked: 'sell_page_home_scr_clicked',
    sell_mobile_page: 'sell_mobile_page',
    origin: 'sell'
};
export const AD_IMPRESSION_DATA = 'ad_impression_data';
